module.exports = __webpack_public_path__ + "img/Suola_Deambulante_SX.eb29c18f.png";